import dayjs from "dayjs"
import "dayjs/locale/hu"
import utc from "dayjs/plugin/utc"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import customParseFormat from "dayjs/plugin/customParseFormat"
import localizedFormat from "dayjs/plugin/localizedFormat"

dayjs.extend(utc)
dayjs.extend(isSameOrBefore)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)
dayjs.locale("hu")

export default dayjs
